import type { TRuleWithTheme } from '@/styles/theme';

export const dropdown: TRuleWithTheme = () => ({
    '&.ant-dropdown .ant-dropdown-menu': {
        width: 'max-content',
    },
});
